import { render, staticRenderFns } from "./ReAssignCartId.vue?vue&type=template&id=64357968&"
import script from "./ReAssignCartId.vue?vue&type=script&lang=js&"
export * from "./ReAssignCartId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports